<app-toast />
<p-confirmDialog />

<app-card-content [border]="false" [title]="titulo()" [icon]="'pi pi-th-large'">
    <div card-subtitle class="text-sm text-muted-color">{{ descricao() }}</div>

    <div card-header class="flex items-center gap-2">
        <p-button label="Adicionar" icon="pi pi-plus" severity="primary" (onClick)="abrirNovo()" [appCan]="roleServicosEditar" />
    </div>

    <!-- ── Filtros ── -->
    <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
        <app-filtro-campo [label]="isUsuarioBR() ? 'Filtrar por UF' : 'UF'">
            <div class="flex items-center gap-2 h-full">
                <!-- Alternar entre "a minha UF" e "todas" só faz sentido para quem enxerga mais de uma. -->
                @if (isUsuarioBR()) {
                    <p-toggleswitch [ngModel]="filtrarPorUf()" (ngModelChange)="onFiltrarPorUfChange($event)" />
                }
                <app-estado-select class="flex-1 min-w-0" [uf]="ufFiltro()" [disabled]="ufTravada() || !filtrarPorUf()" (ufChange)="onEstadoChange($event)" />
            </div>
        </app-filtro-campo>
        <app-filtro-campo label="Nome, descrição ou URL" [wide]="true" inputId="servicos-filtro-texto">
            <input id="servicos-filtro-texto" pInputText type="text" class="w-full" [ngModel]="filtroInput()" (ngModelChange)="filtroInput.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Ex.: Intranet, Certidões..." />
        </app-filtro-campo>
        <app-filtro-campo label="Ordenação">
            <p-select [options]="sortOpcoes" [ngModel]="sortSelecionado()" (ngModelChange)="onSortChange($event)" optionLabel="label" placeholder="Ordenar por..." styleClass="w-full" appendTo="body" />
        </app-filtro-campo>
    </app-filtros-bar>

    <div class="flex flex-col gap-5 pt-1 mb-10">
        <!-- Barra de status -->
        <div class="flex justify-between items-center gap-3">
            <div class="flex items-center gap-2">
                <span class="text-sm text-surface-400 dark:text-surface-500">
                    <span class="font-bold text-surface-700 dark:text-surface-200">{{ totalRecords() }}</span>
                    {{ totalRecords() === 1 ? 'serviço' : 'serviços' }}
                </span>
                @if (filtrarPorUf() && ufFiltro()) {
                    <span class="inline-flex items-center gap-1 bg-primary/10 dark:bg-primary/20 text-primary text-[10px] font-bold px-2.5 py-0.5 rounded-full tracking-wide">
                        <i class="pi pi-map-marker" style="font-size: 0.55rem"></i>
                        {{ ufFiltro() }}
                    </span>
                } @else if (!filtrarPorUf()) {
                    <span class="inline-flex items-center gap-1 bg-surface-100 dark:bg-surface-700 text-surface-500 dark:text-surface-400 text-[10px] font-bold px-2.5 py-0.5 rounded-full tracking-wide">
                        <i class="pi pi-globe" style="font-size: 0.55rem"></i>
                        Todas as UFs
                    </span>
                }
            </div>
            <app-table-view-switcher [viewMode]="viewMode()" (viewModeChange)="viewMode.set($event)" />
        </div>

        @if (carregando()) {
            <div class="flex flex-col items-center justify-center py-20 gap-3">
                <i class="pi pi-spin pi-spinner text-3xl text-primary opacity-50" aria-hidden="true"></i>
                <span class="text-xs text-surface-400 tracking-widest uppercase">Carregando</span>
            </div>

            <!-- View: Cards -->
        } @else if (viewMode() === 'card') {
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                @for (item of items(); track item.codigo ?? item.servico) {
                    <app-card-container (click)="abrirDetalhe(item)">
                        <div class="flex flex-col gap-3 h-full">
                            <div class="flex items-start justify-between gap-2">
                                <span class="servico-icone">
                                    <i [class]="item.icon || 'pi pi-th-large'" aria-hidden="true"></i>
                                </span>
                                <div class="flex items-center gap-1">
                                    <p-button
                                        icon="pi pi-pencil"
                                        [text]="true"
                                        [rounded]="true"
                                        size="small"
                                        pTooltip="Editar"
                                        [ariaLabel]="'Editar ' + item.servico"
                                        (onClick)="abrirDetalhe(item)"
                                        (click)="$event.stopPropagation()"
                                        [appCan]="roleServicosEditar"
                                    />
                                    <p-button
                                        icon="pi pi-trash"
                                        severity="danger"
                                        [text]="true"
                                        [rounded]="true"
                                        size="small"
                                        pTooltip="Remover"
                                        [ariaLabel]="'Remover ' + item.servico"
                                        (onClick)="confirmarRemocao(item)"
                                        (click)="$event.stopPropagation()"
                                        [appCan]="roleServicosExcluir"
                                    />
                                </div>
                            </div>
                            <h3 class="text-base font-semibold text-color truncate" [pTooltip]="item.servico">{{ item.servico }}</h3>
                            <p class="text-sm text-muted-color line-clamp-3 flex-1">{{ item.descricao }}</p>
                            <a class="text-xs text-primary truncate inline-flex items-center gap-1" [href]="item.url" target="_blank" rel="noopener" (click)="$event.stopPropagation()">
                                <i class="pi pi-external-link" style="font-size: 0.7rem" aria-hidden="true"></i>
                                {{ item.url }}
                            </a>
                        </div>
                    </app-card-container>
                } @empty {
                    <div class="col-span-full flex flex-col items-center justify-center py-12 text-surface-400">
                        <i class="pi pi-inbox text-5xl mb-3" aria-hidden="true"></i>
                        <span>Nenhum serviço encontrado.</span>
                    </div>
                }
            </div>

            <!-- View: Tabela -->
        } @else {
            <p-table [value]="items()" dataKey="codigo" [tableStyle]="{ 'min-width': '48rem' }" [rowHover]="true" stripedRows>
                <ng-template pTemplate="header">
                    <tr>
                        <th class="w-16 text-center"><strong>Ícone</strong></th>
                        <th class="w-64"><strong>Nome</strong></th>
                        <th class="w-20 text-center"><strong>UF</strong></th>
                        <th><strong>Descrição</strong></th>
                        <th class="w-72"><strong>URL</strong></th>
                        <th class="w-24 text-center"><strong>Ações</strong></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr class="cursor-pointer" (click)="abrirDetalhe(item)">
                        <td class="text-center">
                            <span class="servico-icone servico-icone--sm">
                                <i [class]="item.icon || 'pi pi-th-large'" aria-hidden="true"></i>
                            </span>
                        </td>
                        <td>
                            <span class="text-sm font-semibold text-surface-700 dark:text-surface-200">{{ item.servico }}</span>
                        </td>
                        <td class="text-center">
                            <span class="inline-flex items-center bg-primary/10 dark:bg-primary/20 text-primary text-[10px] font-bold px-2 py-0.5 rounded-full tracking-wide">{{ item.uf }}</span>
                        </td>
                        <td>
                            <span class="text-sm text-surface-600 dark:text-surface-400">{{ item.descricao }}</span>
                        </td>
                        <td>
                            <a class="text-xs text-primary truncate block max-w-72" [href]="item.url" target="_blank" rel="noopener" (click)="$event.stopPropagation()">{{ item.url }}</a>
                        </td>
                        <td class="text-center">
                            <div class="flex items-center justify-center gap-1">
                                <p-button
                                    icon="pi pi-pencil"
                                    [text]="true"
                                    [rounded]="true"
                                    size="small"
                                    (onClick)="abrirDetalhe(item)"
                                    (click)="$event.stopPropagation()"
                                    pTooltip="Editar"
                                    [ariaLabel]="'Editar ' + item.servico"
                                    [appCan]="roleServicosEditar"
                                />
                                <p-button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    [text]="true"
                                    [rounded]="true"
                                    size="small"
                                    (onClick)="confirmarRemocao(item)"
                                    (click)="$event.stopPropagation()"
                                    pTooltip="Remover"
                                    [ariaLabel]="'Remover ' + item.servico"
                                    [appCan]="roleServicosExcluir"
                                />
                            </div>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6" class="py-12 text-center text-sm text-surface-400 dark:text-surface-600 italic">Nenhum serviço encontrado.</td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="footer">
                    <tr class="custom-table-footer">
                        <td colspan="4">
                            <strong>Total de Registros: {{ totalRecords() }}</strong>
                        </td>
                        <td colspan="2" class="text-right">
                            <strong>Exibindo: {{ exibindoLabel() }}</strong>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        }

        <p-paginator (onPageChange)="onPageChange($event)" [first]="currentPage() * pageSize()" [rows]="pageSize()" [totalRecords]="totalRecords()" [rowsPerPageOptions]="[10, 20, 50]" [appendTo]="'body'" styleClass="mt-2" />
    </div>
</app-card-content>

<app-servico-detalhe [visivel]="detalheAberto()" (visivelChange)="detalheAberto.set($event)" [servico]="servicoEditando()" [ufPadrao]="ufFiltro()" (salvo)="onSalvo()" />
